import PersonaOfficeShell from "@/components/PersonaOfficeShell";
import {
  Sparkles, Globe, IdCard, Calendar, MapPin, ShoppingCart, Users, Drama, Theater,
} from "lucide-react";

/** L6 · Event Production Company dashboard.
 *  Owns concerts, weddings, product launches, festivals, corporate offsites. */
const CONFIG = {
  layer:            "L6",
  label:            "Event Production",
  testidPrefix:     "event-office",
  accent:           "#EC4899",
  Icon:             Sparkles,
  expectedOrgType:  "event_production",
  blurb:            "Live experience command centre — venues, vendors, run-of-show, and every crew member on-mic.",
  tiles: [
    {
      key: "calendar", TileIcon: Calendar,
      title: "Events Calendar",
      desc:  "Every scheduled event across concerts, launches, weddings, festivals.",
      chip: "Soon", chipTone: "soon",
    },
    {
      key: "venues", to: "/directory/orgs?type=studio_infra", TileIcon: MapPin,
      title: "Venues & Locations",
      desc:  "Discover shoot floors, indie locations and event spaces bookable across India.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "vendors", to: "/directory/orgs?type=vendor", TileIcon: ShoppingCart,
      title: "Vendor Directory",
      desc:  "Lighting, sound, catering, transport — every verified vendor in one place.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "variety", to: "/directory?talent_subtype=variety_performer", TileIcon: Drama,
      title: "Book a Variety Artist",
      desc:  "Comics, magicians, dancers, musicians — book live acts for corporates, weddings, festivals.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "theater_halls", to: "/theater/halls", TileIcon: Theater,
      title: "Theater Halls",
      desc:  "Book proscenium, black-box, or amphitheatre venues for shows, comedy nights, launches.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "team", to: "/directory", TileIcon: Users,
      title: "Crew Directory",
      desc:  "Search verified crew: stage managers, riggers, technicians, hosts, floor managers.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "public-profile", to: "/office/public-profile", TileIcon: Globe,
      title: "Public Profile",
      desc:  "Your agency's face for brands & venues — case studies, reel, event calendar.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "icard", to: "/icard", TileIcon: IdCard,
      title: "Owner iCard",
      desc:  "Your verified, co-branded identity card.",
      chip: "Live", chipTone: "live",
    },
  ],
};

export default function EventProductionDashboard() {
  return <PersonaOfficeShell config={CONFIG} />;
}
